<div class="card atividade-list">
    <div class="card-header">
		<div class="btn-group calendar-change-view-btns">
			<div class="btn btn-light"
				(click)="setView(CalendarView.Day, false)"
				[class.active]="view === CalendarView.Day">
				Dia
			</div>			
			<div class="btn btn-light"
				(click)="setView(CalendarView.Week, false)"
				[class.active]="view === CalendarView.Week">
				Semana
			</div>
			<div class="btn btn-light"
				(click)="setView(CalendarView.Month, false)"
				[class.active]="view === CalendarView.Month">
				Mês
			</div>	
			<div class="btn btn-light"
				(click)="setView(null, true)"
				[class.active]="isPeriodoView">
				Período
			</div>            		
		</div>
        
		<div class="card-header-view-date">
			<h4 class="calendar-view-date-title" *ngIf="!isPeriodoView">{{ viewDate | calendarDate:(view + 'ViewTitle'): locale }}</h4>
			<div class="input-group input-group-periodo" *ngIf="isPeriodoView">
				<!-- <div class="input-group-prepend">
					<button type="button" class="btn btn-light btn-this-week" (click)="goToEssaSemanaClick()">Essa Semana</button>
				</div>                     -->
				<sgt-datepicker [(ngModel)]="filter.diaPrazoInicial" (ngModelChange)="onPeriodoChange()" name="atividadeFilterDiaPrazoInicial" id="atividadeFilterDiaPrazoInicial"
					#atividadeFilterDiaPrazoInicial="ngModel" #diaPrazoInicial [ngControl]="atividadeFilterDiaPrazoInicial" 
					containerClasses="container-datepicker-dia-prazo-inicial">
				</sgt-datepicker>
				<div class="input-group-append">
				  <span class="input-group-text">até</span>
				</div>
				<sgt-datepicker [(ngModel)]="filter.diaPrazoFinal" (ngModelChange)="onPeriodoChange()" name="atividadeFilterDiaPrazoFinal" id="atividadeFilterDiaPrazoFinal"
					#atividadeFilterDiaPrazoFinal="ngModel" [ngControl]="atividadeFilterDiaPrazoFinal" 
					containerClasses="container-datepicker-dia-prazo-final">
				</sgt-datepicker>
			</div>
		</div>

		<div class="calendar-change-view-date-btns btn-group" *ngIf="!isPeriodoView">
			<div class="btn btn-light"
				mwlCalendarPreviousView
				[view]="view"
				[viewDate]="viewDate"
				(viewDateChange)="onViewDateChange($event)">
				<i class="fas fa-long-arrow-alt-left"></i>
			  </div>
			<div class="btn btn-light"
				mwlCalendarToday
				[viewDate]="viewDate"
				(viewDateChange)="onViewDateChange($event)">
				Hoje
			</div>			
			<div class="btn btn-light"
				mwlCalendarNextView
				[view]="view"
				[viewDate]="viewDate"
				(viewDateChange)="onViewDateChange($event)">
				<i class="fas fa-long-arrow-alt-right"></i>
			</div>
		</div>        
    </div>

    <table class="table table-striped table-hover table-bordered table-atividade-list" id="tableAtividadeList">
        <thead>
            <tr>
                <th class="col-options text-center"></th>
                <th class="col-status text-center"></th>
                <th class="col-flags text-center"></th>
                <th class="col-id text-right">#</th>
                <th class="col-tipo text-center">Tipo</th>
                <th class="col-data-emissao text-center">Emissão</th>
                <th class="col-data-prazo text-center">Prazo</th>
                <th class="col-data-conclusao text-center">Conclusão</th>
                <th class="col-cliente">Cliente</th>
                <th class="col-titulo">Título</th>
                <th class="col-comentario">Comentário</th>
                <th class="col-responsavel">Responsável</th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td colspan="12" class="text-left">
                    {{atividadesTotal?.quantidadeAtividades | decimalFormat: 1:0:0}} atividade(s)
                </td>               
            </tr>
        </tfoot>
    </table>     
</div>